module.exports = {
  "chat.end":"Reinicie su conversación de chat",
  "chat.endall":"Chat finalizado",
  "chat.cancel":"Cancelar",
  "chat.cookie":"Este asistente digital utiliza cookies para garantizar que obtenga la mejor experiencia",
  "chat.learn":"Aprende más",
  "chat.minimize":"Minimizar",
  "chat.hide":"Cerca",
  "chat.hidebot.text":"Cerrar hará que la avatar desaparezca durante 15 minutos.",
  "chat.hidebot":"Cerrar robot",
  "chat.restart":"Reiniciar",
  "switch.language":"Cambiar de idioma",
  "switch.property":"Cambiar propiedad",
  "restart.converstation":"Reiniciar conversación",
  "chat.endtext":"¿Está seguro de que desea finalizar el chat actual?",
  "check.availabity":"Consultar disponibilidad",
  "check.availabity.submit":"Enviar",
  "check.availabity.cancel":"Cancelar",
  "check.availabity.adults":"Adultas ",
  "check.availabity.children":"Niñas",
  "check.availabity.child.age":"Edad - niña",
  "feedback.leave":"Deja un comentario",
  "feedback.leave.message":"Deja un mensaje"
};
